const TRY_FIRST_PREVIEW_KEY = "redo.tryFirstPreview";
const TRY_FIRST_PREVIEW_PARAM = "tryFirstPreview";

export function getPreviewModeAndStoreInLocalStorage(): boolean {
  const urlParams = new URLSearchParams(window.location.search);
  const previewParam = urlParams.get(TRY_FIRST_PREVIEW_PARAM);

  if (previewParam && ["true", "false"].includes(previewParam)) {
    localStorage.setItem(TRY_FIRST_PREVIEW_KEY, previewParam);
  }

  const isEnabled =
    previewParam === "true" ||
    localStorage.getItem(TRY_FIRST_PREVIEW_KEY) === "true";

  return isEnabled;
}
